import { Icon } from '@iconify/react';
import type { FC } from 'react';

import Text from '@/components/Text';

type Props = {
  icon: string;
  label: string;
  value?: string | null;
  layout?: 'simple' | 'advanced';
};

const GithubDataField: FC<Props> = ({
  icon,
  label,
  value,
  layout = 'advanced',
}) => {
  const content = (() => {
    if (layout === 'advanced')
      return (
        <div className="flex flex-col">
          <Text variant="body-caption" className="text-neutral-300">
            {label}
          </Text>
          <Text variant="body-small" className="font-semibold text-neutral-100">
            {value || '-'}
          </Text>
        </div>
      );
    return (
      <Text variant="body-small" className="font-semibold">
        {label} <span className=" text-primary-300">{value || '-'}</span>
      </Text>
    );
  })();

  return (
    <div className="flex items-center gap-2 rounded-lg bg-neutral-800 px-4 py-2">
      <Icon icon={icon} className="text-3xl text-neutral-300" />
      {content}
    </div>
  );
};

export default GithubDataField;
